import React from "react";
import { ErrorOutline } from "@mui/icons-material";
import { Box, FormHelperText } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";
import { ValidationErrors } from "final-form";

import { ExtendedPermission } from "fond/types";

import { Cell, InfoHelperText } from "./PermissionsField.styles";

interface IUsernameCellRendererProps extends ICellRendererParams<ExtendedPermission, ExtendedPermission> {
  submitErrors: ValidationErrors;
  allExpired: boolean;
}

const UsernameCellRenderer: React.FC<IUsernameCellRendererProps> = ({ allExpired, node, value, submitErrors }) => {
  const submitError = submitErrors?.[node.sourceRowIndex];

  if (!value) return null;

  return (
    <Cell data-testid="share-permission-user-id">
      <span>{value.IdentityType === "user" ? value.Identity.Email : value.Identity.Name}</span>
      {value.Guest && value.Downgraded && (
        <Box display="flex" alignItems="start" data-testid="guest-permission-limit-notice">
          <ErrorOutline color="primary" />
          <InfoHelperText>This user is not part of this account and cannot be granted permissions higher than collaborator</InfoHelperText>
        </Box>
      )}
      {typeof value.License !== "undefined" && (!value.License || allExpired) && (value.Level === "manage" || value.Level === "write") && (
        <Box display="flex" alignItems="start" data-testid="no-license-notice">
          <ErrorOutline color="error" />
          <InfoHelperText sx={{ color: (theme) => theme.palette.biarri.primary.red }}>
            This user&nbsp;
            {!value.License ? "does not have a license." : "has an expired license."}
            &nbsp;A valid license will be required to create and manage content.
          </InfoHelperText>
        </Box>
      )}
      {submitError && (
        <FormHelperText error data-testid="permission-helper-error">
          {`${submitError}`}
        </FormHelperText>
      )}
    </Cell>
  );
};

export default UsernameCellRenderer;
